import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  headerMessage: "Community Management", // Shared state
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setHeaderMessage: (state, action) => {
      state.headerMessage = action.payload;
    },
  },
});

export const { setHeaderMessage } = uiSlice.actions;
export default uiSlice.reducer;
